import React from 'react';
import { MoneyInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const converter = require('number-to-words');

const required = (value) =>
  isValidGlobalBehaviour(value, 'numberWithoutZero') ? undefined : 'Required';

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const convertValue = (values, pounds) => {
  if (
    values.annualSales !== undefined &&
    values.annualSales !== null &&
    isValidGlobalBehaviour(values.annualSales, 'numberWithoutZero')
  ) {
    const word = converter.toWords(values.annualSales) + pounds;
    return capitalizeFirstLetter(word);
  }
  return '';
};

const SalesField = ({ formFieldValues, maxSalesLength }) => (
  <Content>
    {({ businessSales, businessSalesError, pounds, totalValueOfSalesText }) => (
      <Field name="annualSales" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="annualSales"
            title={businessSales}
            validationMessage={touched && !!error && businessSalesError}
            description={totalValueOfSalesText}
          >
            <Field name="annualSales" type="input" validate={required}>
              {({ input }) => (
                <MoneyInput.WithPence
                  id="annualSales"
                  amountInPence={formFieldValues.annualSales * 100}
                  maxLength={maxSalesLength}
                  {...input}
                  onChange={({ value }) => {
                    const valueWithoutPence = value / 100;
                    if (valueWithoutPence && valueWithoutPence.toString().length > maxSalesLength)
                      return;
                    input.onChange(valueWithoutPence);
                  }}
                />
              )}
            </Field>

            <div className="c-m-form-field__footer c-a-field-helper">
              <p>{convertValue(formFieldValues, pounds)}</p>
            </div>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

SalesField.propTypes = {
  formFieldValues: PropTypes.shape({}),
  maxSalesLength: PropTypes.number
};

SalesField.defaultProps = {
  formFieldValues: {},
  maxSalesLength: 8
};

export default SalesField;
